// third-party
import { createSlice } from '@reduxjs/toolkit';

// Remove circular dependency - dispatch will be used from component level

// initial state
const initialState = {
  openItem: ['dashboard'],
  defaultId: 'dashboard',
  openComponent: 'buttons',
  drawerOpen: false,
  componentDrawerOpen: true
};

// ==============================|| SLICE - MENU ||============================== //

const menu = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    activeItem(state, action) {
      state.openItem = action.payload.openItem;
    },

    activeComponent(state, action) {
      state.openComponent = action.payload.openComponent;
    },

    openDrawer(state, action) {
      state.drawerOpen = action.payload.drawerOpen;
    },

    openComponentDrawer(state, action) {
      state.componentDrawerOpen = action.payload.componentDrawerOpen;
    }
  }
});

export default menu.reducer;

export const { activeItem, activeComponent, openDrawer, openComponentDrawer } = menu.actions;

// Action creators for thunk actions
export const activeItemAction = (openItem) => (dispatch) => {
  dispatch(activeItem({ openItem }));
};

export const activeComponentAction = (openComponent) => (dispatch) => {
  dispatch(activeComponent({ openComponent }));
};

export const openDrawerAction = (drawerOpen) => (dispatch) => {
  dispatch(openDrawer({ drawerOpen }));
};

export const openComponentDrawerAction = (componentDrawerOpen) => (dispatch) => {
  dispatch(openComponentDrawer({ componentDrawerOpen }));
};